import React from 'react'
import { Spin } from 'antd'

const Loader = () => {
    return (
        <div className='Loader'>
            <Spin />
        </div>
    )
}

export default Loader
